import React from 'react';
import './IndustrySpecific.scss';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Owl from '../UI/Graphics/Owl';
import { COLORS } from '../../constants/colors';

/**
 * @param {string} heading
 * @param {string} description
 * @param {Object} featuredImage
 * @param {Object} cta
 * @returns {JSX.Element}
 * @constructor
 */
const IndustrySpecific = ({ heading, description, featuredImage, cta }) => (
  <div className="c-industry-specific background-color-blue">
    <div className="c-industry-specific__content">
      <div className="c-industry-specific__heading-container background-color-white">
        <h2 className="c-industry-specific__heading h2-roobert color-black">{heading}</h2>
      </div>

      <div className="c-industry-specific__bottom">
        <div className="c-industry-specific__description-container">
          <h4 className="c-industry-specific__description h4-roobert color-gray">{description}</h4>
          <Owl color={COLORS.white} />
        </div>
        <div className="c-industry-specific__featured-img-container">
          <img
            src={featuredImage.url}
            alt={featuredImage.alt}
            className="c-industry-specific__featured-img"
          />
        </div>
      </div>

      <div className="c-industry-specific__cta">
        <CTAButton text={cta.label} link={cta.link} additionalClasses="cta" />
      </div>
    </div>
  </div>
);

export default IndustrySpecific;
